import { route } from 'src/components/common/router/Router';
import { cartAtom, selectCartComposition } from 'src/state/cart/cartAtom';
import { showBasketAtom } from 'src/state/ui/showBasket.atom';

/**
 * Routes to the appropriate checkout destination based on cart composition
 * This is used when skipBasketOnBook is enabled to ensure waiting list items
 * are handled correctly
 */
export function routeToAppropriateCheckout(): void {
    const cartItems = cartAtom.subject.value;
    const cartComposition = selectCartComposition(cartItems);

    switch (cartComposition) {
        case 'waitingListOnly':
            route('/waitlist');
            break;
        case 'regularOnly':
            route('/checkout');
            break;
        case 'mixed':
            // For mixed carts, show the basket so user can choose which flow to take
            showBasketAtom.update({
                visible: true,
            });
            break;
        case 'empty':
            // This shouldn't happen in normal flow, but fallback to checkout
            route('/checkout');
            break;
    }
}
